import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

export interface OnboardingData {
	energy: "electricity" | "gas";
	isCommercial: boolean;
	address: { [key: string]: any }; // structure  address from experian TODO:// maybe type this better
	nmi?: string;
	promoCode?: string;
	productType?: string;
	plan?: { [key: string]: any };
	aseXML?: string;
	installationTypeCode?: string;
}

type OnboardingStore = {
	data: OnboardingData | null;
	hasHydrated: boolean;
	setOnboardingData: (data: OnboardingData) => void;
	clearOnboardingData: () => void;
	setHasHydrated: (hydrated: boolean) => void;
};

export const useOnboardingStore = create<OnboardingStore>()(
	devtools(
		persist(
			(set, get) => ({
				data: null,
				hasHydrated: false,
				setOnboardingData: data => set({ data }),
				clearOnboardingData: () => set({ data: null }),
				setHasHydrated: hydrated => set({ hasHydrated: hydrated }),
			}),
			{
				name: "solstice-onboarding-store",
				storage: createJSONStorage(() => sessionStorage),
				onRehydrateStorage: () => state => {
					state?.setHasHydrated(true);
				},
			},
		),
		{ enabled: process.env.NODE_ENV === "development" },
	),
);
